$(document).ready(function() {
  if (window.location.pathname === '/cart') {
    $('.cart__footer-wrapper .cart__ctas .cart__checkout-button').on('click', function() {
      window.location.href = '/checkout';
    });
  }
});

var checkInterval1 = setInterval(function () {
  if ($(".product .shopify-app-block").length > 0) {
    $(".product .shopify-app-block .foxkit-related-products__wrapper .foxkit-related-products__grid .swiper-wrapper.foxkit-hidden").remove();
    setTimeout(function(){
      $(".product .shopify-app-block .foxkit-related-products__wrapper .foxkit-related-products__grid").owlCarousel({
        loop: false,
        margin: 10,
        nav: true,
        dots: false,
        responsive: {
          0: {
            items: 1,
          },
          420: {
            items: 2,
          },
          600: {
            items: 3,
          },
          1000: {
            items: 4,
          },
        },
      });
      clearInterval(checkInterval1);
    }, 500);
  }
}, 1000);

var width = window.innerWidth;

var checkInterval = setInterval(function() {
  if ($('.product .grid__item.product__media-wrapper .custom-media-app-grid div.shopify-block.shopify-app-block').length > 0) {
      $('.product .grid__item.product__media-wrapper .custom-media-app-grid div.shopify-block.shopify-app-block:not(:has(.foxkit-related-products.foxkit-related-products))').remove();
      if(width > 991){
        $('.product .product__info-wrapper div.shopify-block.shopify-app-block:has(foxkit-related-products.foxkit-related-products)').remove();
      } else {
        $('.product .grid__item.product__media-wrapper .custom-media-app-grid .shopify-block.shopify-app-block foxkit-related-products.foxkit-related-products').remove();
      }
      $('.product .shopify-block.shopify-app-block foxkit-related-products.foxkit-related-products .foxkit-related-products__grid .swiper-wrapper.foxkit-hidden').remove();
      $('.product .shopify-block.shopify-app-block foxkit-related-products.foxkit-related-products .foxkit-related-products__grid').owlCarousel({
        loop: false,
        margin: 10,
        nav: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 1000, 
        responsive:{
          0:{
            items:1
          },
          420:{
            items:2
          },
          1000:{
            items:2
          },
          1400:{
            items:4
          }
        }
      });
        clearInterval(checkInterval);
    }
}, 1000);

$(document).on('click', '.card__information .product-details .product-options fieldset label', function() {
  var variantsdata;
  if ($(this).parent().parent().hasClass('owl-item')) {
    variantsdata = JSON.parse($(this).parent().parent().parent().parent().parent().parent().siblings('script').html());
  } else {
    variantsdata = JSON.parse($(this).parent().parent().parent().siblings('script').html());
  }

  setTimeout(function() {
    var options = {};
    var context = this;
    var fieldsets;
    if ($(this).parent().parent().hasClass('owl-item')) {
      fieldsets = $(this).parent().parent().parent().parent().parent().parent().find('fieldset');
    } else {
      fieldsets = $(this).parent().parent().parent().find('fieldset');
    }

    for (var index = 0; index < 3; index++) {
      var fieldset = fieldsets[index];
      var optionElement = null;
      if (fieldset) {
        var radioElement = $(fieldset).find('input[type="radio"]:checked');
        var selectElement = $(fieldset).find('select');
        if (radioElement.length > 0) {
          optionElement = radioElement;
        } else if (selectElement.length > 0) {
          optionElement = selectElement;
        }
      }
      var option = optionElement ? optionElement.val() : null;
      var i = index + 1;
      options['option' + i] = {
        value: option
      };
    }

    if (!options.option2) {
      options.option2 = { value: null };
    }
    if (!options.option3) {
      options.option3 = { value: null };
    }

    var absolute = variantsdata.filter(function(item) {
      return item.option1 == options.option1.value && item.option2 == options.option2.value && item.option3 == options.option3.value;
    });

    var variantid = absolute.length > 0 ? absolute[0].id : false;
    var variantavailable = absolute.length > 0 ? absolute[0].available : false;
    var variantimage = absolute.length > 0 && absolute[0].featured_image ? absolute[0].featured_image.src : null;
    var variantprice = absolute.length > 0 ? absolute[0].price : false;
    var variantcompareprice = absolute.length > 0 ? absolute[0].compare_at_price : false;
    var nprice = variantprice !== false ? (variantprice / 100).toFixed(2) : '0.00';
    var ncomapreatprice = variantcompareprice !== false ? (variantcompareprice / 100).toFixed(2) : '0.00';
    var price = parseFloat(nprice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var comapreatprice = parseFloat(ncomapreatprice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var $currentElement = $(this);
    var $testDiv = null;
    while ($currentElement.length) {
        if ($currentElement.hasClass('product-details')) {
            $testDiv = $currentElement;
            break;
        }
        $currentElement = $currentElement.parent();
    }
    var pricesection = $testDiv.parent().find('.card-information .price');

    if (variantid) {
      if ($(this).parent().parent().hasClass('owl-item')) {
        var form = $(this).parent().parent().parent().parent().parent().parent().find('form.form');
      } else {
        var form = $(this).parent().parent().parent().find('form.form');
      }
      form.find('input[name="id"]').val(variantid);

      if (variantimage) {
        var images = form.closest('.card-wrapper').find('.card__inner.gradient .card__media .media img');
        images.each(function() {
          $(this).attr('srcset', '').attr('src', variantimage);
        });
      }

      var addToBagButton = form.find('button[name="Add To bag"]');
      if (!variantavailable) {
        addToBagButton.html('Sold Out').prop('disabled', true);
      } else {
        addToBagButton.html('Add To Cart').prop('disabled', false);
      }

      if(comapreatprice != null && comapreatprice > price){
        var percentageOff = ((ncomapreatprice - nprice) / ncomapreatprice) * 100;
        // console.log(percentageOff);
        // console.log(Math.round(percentageOff));
        pricesection.addClass('price--on-sale');
        pricesection.find('.price__container .price__sale span s.price-item.price-item--regular').html('R ' + comapreatprice + ' ZAR');
        pricesection.find('.price__container .price__sale span.price-item.price-item--sale.price-item--last').html('R ' + price + ' ZAR');
        if(pricesection.find('span.price-item.sale-persentage').length == 0){
          var presentage = $(document.createElement('span'));
          presentage.addClass('price-item, sale-persentage');
          pricesection.find('.price__container').before(presentage);
        }
        pricesection.find('span.price-item.sale-persentage').html('-' + Math.round(percentageOff) + '%');
      } else {
        pricesection.removeClass('price--on-sale');
        pricesection.find('.price__container .price__sale span s.price-item.price-item--regular').html('');
        pricesection.find('span.price-item.sale-persentage').html('');
        pricesection.find('.price__container .price__regular span.price-item.price-item--regular').html('R ' + price + ' ZAR');
      }
    }
  }.bind(this), 400);
});

$(document).on('change', '.card-wrapper .product-details .product-options .selector-wrapper select', function() {
  var variantsdata = JSON.parse($(this).parent().parent().siblings('script').html());
  setTimeout(function() {
    var options = {};
    var fieldsets = $(this).closest('.product-options').find('fieldset');
    for (var index = 0; index < 3; index++) {
      var optionElement = null;
      if (index < fieldsets.length) {
        var radioElement = fieldsets.eq(index).find('input[type="radio"]:checked');
        var selectElement = fieldsets.eq(index).find('select');
        if (radioElement.length > 0) {
          optionElement = radioElement;
        } else if (selectElement.length > 0) {
          optionElement = selectElement;
        }
      }
      var option = optionElement ? optionElement.val() : null;
      options['option' + (index + 1)] = {
        value: option
      };
    }
    
    if (!options.option2) {
      options.option2 = { value: null };
    }
    if (!options.option3) {
      options.option3 = { value: null };
    }
    
    var absolute = variantsdata.filter(function(item) {
      return item.option1 == options.option1.value && item.option2 == options.option2.value && item.option3 == options.option3.value;
    });
    
    var variantid = absolute.length > 0 ? absolute[0].id : false;
    var variantavailable = absolute.length > 0 ? absolute[0].available : false;
    var variantimage = absolute.length > 0 && absolute[0].featured_image ? absolute[0].featured_image.src : null;
    var variantprice = absolute.length > 0 ? absolute[0].price : false;
    var variantcompareprice = absolute.length > 0 ? absolute[0].compare_at_price : false;
    var nprice = variantprice !== false ? (variantprice / 100).toFixed(2) : '0.00';
    var ncomapreatprice = variantcompareprice !== false ? (variantcompareprice / 100).toFixed(2) : '0.00';
    var price = parseFloat(nprice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var comapreatprice = parseFloat(ncomapreatprice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var $currentElement = $(this);
    var $testDiv = null;
    while ($currentElement.length) {
        if ($currentElement.hasClass('product-details')) {
            $testDiv = $currentElement;
            break;
        }
        $currentElement = $currentElement.parent();
    }
    var pricesection = $testDiv.parent().find('.card-information .price');
    
    if (variantid) {
      $(this).parent().parent().find('form.form').find('input[name="id"]').val(variantid);
      
      if (variantimage) {
        var images = $(this).closest('.card-wrapper').find('.card__inner.gradient .card__media .media img');
        images.each(function() {
          $(this).attr('srcset', '').attr('src', variantimage);
        });
      }
      
      var addToBagButton = $(this).parent().parent().find('form.form').find('button[name="Add To bag"]');
      if (!variantavailable) {
        addToBagButton.html('Sold Out').prop('disabled', true);
      } else {
        addToBagButton.html('Add To Cart').prop('disabled', false);
      }

      if(comapreatprice != null && comapreatprice > price){
        var percentageOff = ((ncomapreatprice - nprice) / ncomapreatprice) * 100;
        // console.log(percentageOff);
        // console.log(Math.round(percentageOff));
        pricesection.addClass('price--on-sale');
        pricesection.find('.price__container .price__sale span s.price-item.price-item--regular').html('R ' + comapreatprice + ' ZAR');
        pricesection.find('.price__container .price__sale span.price-item.price-item--sale.price-item--last').html('R ' + price + ' ZAR');
        if(pricesection.find('span.price-item.sale-persentage').length == 0){
          var presentage = $(document.createElement('span'));
          presentage.addClass('price-item, sale-persentage');
          pricesection.find('.price__container').before(presentage);
        }
        pricesection.find('span.price-item.sale-persentage').html('-' + Math.round(percentageOff) + '%');
      } else {
        pricesection.removeClass('price--on-sale');
        pricesection.find('.price__container .price__sale span s.price-item.price-item--regular').html('');
        pricesection.find('span.price-item.sale-persentage').html('');
        pricesection.find('.price__container .price__regular span.price-item.price-item--regular').html('R ' + price + ' ZAR');
      }
    }
  }.bind(this), 400);
});

// $(document).on('submit', '.card__information .product-details .product-options form[data-type="add-to-cart-form"]', function(e) {
//   e.preventDefault();
//   var productId = $(this).find('input[name="id"]').val();
//   // console.log(productId);
//   addToCart(productId);
// });

// document.querySelectorAll('.card__information .product-details .product-options form[data-type="add-to-cart-form"]').forEach(form => {
//   form.addEventListener('submit', (event) => {
//     event.preventDefault();

//     const config = fetchConfig('javascript');
//     config.headers['X-Requested-With'] = 'XMLHttpRequest';
//     delete config.headers['Content-Type'];

//     const formData = new FormData(form);
//     const CusCartDrawer = document.querySelector('cart-drawer');
//     if (CusCartDrawer) {
//       // console.log(CusCartDrawer);
//       formData.append(
//         'sections',
//         CusCartDrawer.getSectionsToRender().map((section) => section.id)
//       );
//       formData.append('sections_url', window.location.pathname);
//       CusCartDrawer.setActiveElement(document.activeElement);
//     }
//     config.body = formData;

//     fetch(`${routes.cart_add_url}`, config)
//       .then((response) => response.json())
//       .then((response) => {
//         // console.log(response);
//         if (response.status) {
//           publish(PUB_SUB_EVENTS.cartError, {
//             source: 'product-form',
//             productVariantId: formData.get('id'),
//             errors: response.errors || response.description,
//             message: response.message,
//           });
//           this.handleErrorMessage(response.description);

//           // const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//           // if (!soldOutMessage) return;
//           // this.submitButton.setAttribute('aria-disabled', true);
//           // this.submitButton.querySelector('span').classList.add('hidden');
//           // soldOutMessage.classList.remove('hidden');
//           this.error = true;
//           return;
//         } else if (!CusCartDrawer) {
//           window.location = window.routes.cart_url;
//           return;
//         }

//         if (!this.error)
//           publish(PUB_SUB_EVENTS.cartUpdate, {
//             source: 'product-form',
//             productVariantId: formData.get('id'),
//             cartData: response,
//           });
//         this.error = false;
//         const quickAddModal = form.closest('quick-add-modal');
//         if (quickAddModal) {
//           document.body.addEventListener(
//             'modalClosed',
//             () => {
//               setTimeout(() => {
//                 CusCartDrawer.renderContents(response);
//               });
//             },
//             { once: true }
//           );
//           quickAddModal.hide(true);
//         } else {
//           CusCartDrawer.renderContents(response);
//         }
//       })
//       .catch((e) => {
//         console.error(e);
//       })
//       .finally(() => {
//         // this.submitButton.classList.remove('loading');
//         if (CusCartDrawer && CusCartDrawer.classList.contains('is-empty')){
//           CusCartDrawer.classList.remove('is-empty');
//         }
//         // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//         form.querySelector('.loading__spinner').classList.add('hidden');
//       });
//   });
// });

window.handleSubmit = function(form) {
    event.preventDefault();

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(form);
  const CusCartDrawer = document.querySelector('cart-drawer');
  if (CusCartDrawer) {
    formData.append(
      'sections',
      CusCartDrawer.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    CusCartDrawer.setActiveElement(document.activeElement);
  }
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      // console.log(response);
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.errors || response.description,
          message: response.message,
        });
        // Handle error message display or actions here
        // For example: this.handleErrorMessage(response.description);
        return;
      } else if (!CusCartDrawer) {
        window.location = window.routes.cart_url;
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: formData.get('id'),
        cartData: response,
      });

      const quickAddModal = form.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              CusCartDrawer.renderContents(response);
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        CusCartDrawer.renderContents(response);
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      // form.querySelector('.loading__spinner').classList.add('hidden');
      if (CusCartDrawer && CusCartDrawer.classList.contains('is-empty')) {
        CusCartDrawer.classList.remove('is-empty');
      }
    });
  };


// function addToCart(productId) {
//     var data = {
//         items: [
//             {
//                 quantity: 1,
//                 id: productId
//             }
//         ]
//     };

//     $.ajax({
//         type: 'POST',
//         url: '/cart/add.js', // Shopify AJAX endpoint
//         data: JSON.stringify(data),
//         dataType: 'json',
//         contentType: 'application/json',
//         success: function(response) {
//             document.dispatchEvent(new CustomEvent("cart:refresh:opend"));
//             console.log('Product added to cart!', response);

//             // Fetch the updated cart contents
//             fetch('/cart.js', {
//                 method: 'GET',
//                 headers: {
//                     'X-Requested-With': 'XMLHttpRequest'
//                 }
//             })
//             .then(response => response.json())
//             .then(cart => {
//                 // Update the cart drawer contents
//                 const customCartDrawer = document.querySelector('cart-drawer');
//               console.log(customCartDrawer);
//               customCartDrawer.open();
//               for (let i = 0; i < cart.items.length; i++) {
//                 var item = cart.items[i];
//                 customCartDrawer.renderContents(item);
//               }
//             })
//             .catch(error => console.error('Error fetching cart contents:', error));
//         },
//         error: function(xhr, status, error) {
//             console.error(error);
//         }
//     });
// }
    $(document).on('mouseenter', 'div#ProductGridContainer .collection ul#product-grid li.grid__item .card-wrapper', function() {
  var cardWrapper = $(this);
  if (cardWrapper.find('.item').length > 4) {
    cardWrapper.find('.card__information .product-options fieldset.product-form__input').owlCarousel({
      loop: false,
      margin: 10,
      nav: true,
      dots: false,
      responsive: {
        0: {
          items: 4
        },
        414: {
          items: 4
        },
        425: {
          items: 4
        },
        600: {
          items: 4
        },
        1000: {
          items: 4
        }
      }
    });
  }
});
$(document).on('mouseleave', 'div#ProductGridContainer .collection ul#product-grid li.grid__item .card-wrapper', function() {
  $(this).find('.card__information .product-options fieldset.product-form__input').trigger('destroy.owl.carousel');
});


  $('#FacetFiltersForm .facets').on('click', function() {
      $('#FacetFiltersForm .select').toggleClass('active');
      $('#FacetFiltersForm .facet-filters__label').toggleClass('active');
  });

  $('#FacetsWrapperMobile .facets').on('click', function() {
      $('#FacetsWrapperMobile .select').toggleClass('active');
      $('#FacetsWrapperMobile .facet-filters__label').toggleClass('active');
  });

  $('.shopify-section aside#main-collection-filters .facets-container form#FacetFiltersFormMobile div.mobile-facets__main details.mobile-facets__details div.mobile-facets__submenu').each(function(){
    var height = -$(this).height();
    $(this).css('top', height);
  });
  $(window).load(function() {
    $('.custom-main-menu ul.right-icon-group a#cart-icon-bubble').on('click', (e) => {
      e.preventDefault();
      const customCartDrawer = document.querySelector('cart-drawer');
      if (customCartDrawer) {
        customCartDrawer.open();
      } else {
        console.error('cart-drawer element not found in the DOM');
      }
    });

    if(window.location.pathname == '/pages/store-locator'){
      if(width > 991){
        var StoreLocatorInterval = setInterval(function() {
          if ($('body[data-template=store-locator] main#MainContent .page-width .container-fluid div#storeifyapps-storelocator-index .map-tab-ggmap.map-tab-mobile.active div#map').length > 0) {
            var height = $('body[data-template=store-locator] main#MainContent .page-width .container-fluid div#storeifyapps-storelocator-index .map-tab-ggmap.map-tab-mobile.active div#map').height();
            $('body[data-template=store-locator] main#MainContent .page-width .container-fluid div#storeifyapps-storelocator-index .storeifyapps-storelocator-equal').css('max-height', height);
            clearInterval(StoreLocatorInterval);
          }
        }, 1000);
        $(document).resize(function(){
          var height = $('body[data-template=store-locator] main#MainContent .page-width .container-fluid div#storeifyapps-storelocator-index .map-tab-ggmap.map-tab-mobile.active div#map').height();
          $('body[data-template=store-locator] main#MainContent .page-width .container-fluid div#storeifyapps-storelocator-index .storeifyapps-storelocator-equal').css('max-height', height);
        })
      }
    }
    // $(document).on('click', function(e){
    //   console.log($(e.target).closest('.collection #product-grid .grid__item .card-wrapper:has(.product-details.shown)').length);
    //   if ($(e.target).closest('.collection #product-grid .grid__item .card-wrapper:has(.product-details.shown)').length > 0) {
    //     $('.collection #product-grid .grid__item .card-wrapper .card .card__content .card__information:has(.product-details.shown) .mobile-option span.optionlink').click();
    //   }
    // });
    $('.collection #product-grid .grid__item .card-wrapper .card .card__content .card-information + .mobile-option span.optionlink').click(function() {
      // setTimeout(function(){
        var productDetails = $(this).closest('.card-wrapper').find('.product-details');
        if (!productDetails.hasClass('shown')) {
          productDetails.show().addClass('shown');
          $(this).closest('.card-wrapper').trigger('mouseenter');
          $(this).html('Hide Options');
        } else {
          productDetails.hide().removeClass('shown');
          $(this).closest('.card-wrapper').off('mouseenter mouseleave');
          $(this).html('View Options');
        }
      // }, 500);
    });
    if(width < 769){
      $('body[data-templatename="page"] .shopify-section.menu-sec.visible .cms-sidebar .accordian-title').each(function(){
        $(this).click();
      })
    }
    let copyinterval;
    copyinterval = setInterval(() => {
      const copyelement = $('body div[data-dfd-view="Search"]');
      // console.log('3');
      if (copyelement.length) {
        // console.log('2');
        const targetNode = document.querySelector('body div[data-dfd-view="Search"]');

        if (targetNode) {
            const config = { attributes: true, attributeFilter: ['class'] };

            const callback = function(mutationsList, observer) {
              for(let mutation of mutationsList) {
                if (mutation.type === 'attributes') {
                  if (!targetNode.classList.contains('dfd-animate')) {
                    $('input[type="search"]').each(function(){
                      var input = $(this);
                      input.val('');
                    });
                  }
                }
              }
            };

            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        } else {
            console.error('Target node not found');
        }
        clearInterval(copyinterval);
      }
    }, 500);
    $('input[type="search"]').each(function(){
      var input = $(this);
      input.val('');
    });

    if($('body').data('templatename') == 'collection'){
      if($('#ProductGridContainer ul#product-grid').length == 0){
        $('.product-collection-custom .facets-vertical aside#main-collection-filters').hide();
      }
      $('.collection-list-wrapper .card--media .card__inner .card__content').click(function(){
          var redirect = $(this).find('a').attr('href');
          location.href = redirect;
      });
    }
  });
$(window).load(function() {
  
  if(window.location.pathname.indexOf('blog') == 1){
    if(window.location.hash != ''){
      var active_category = window.location.hash.replace('#', '');
      $('body.blog[data-templatename="blog"] main#MainContent section.shopify-section > div:not(.blog-categories, .blog-categories-mobile)').each(function(){
        var oldElement = $(this);
        var newElement = $("<default_blogs>", {
            id: oldElement.attr("id"),
            class: oldElement.attr("class"),
            html: oldElement.html()
        });
        oldElement.replaceWith(newElement);
      });
      $('body.blog[data-templatename="blog"] main#MainContent section.shopify-section > ' + active_category).each(function(){
        var oldElement = $(this);
        var newElement = $("<div>", {
            id: oldElement.attr("id"),
            class: oldElement.attr("class"),
            html: oldElement.html()
        });
        oldElement.replaceWith(newElement);
      });
      var selected_category = window.location.hash;
      $('.blog-categories .blog-category a').each(function () {
        var href = $(this).attr('href');
        if(href == selected_category){
          $(this).addClass('active_category');
        }
      });
    }
  
    const articlesPerPage = window.blog_per_page;
    const $articles = $('div.main-blog.category .blog-articles.blog-articles--custom .article');
    const totalPages = Math.ceil($articles.length / articlesPerPage);
    let currentPage = 1;
  
    function generatePagination() {
      let paginationHtml = '<div class="pagination">';
      paginationHtml += '<span class="prev">Previous</span>';
      for (let i = 1; i <= totalPages; i++) {
        paginationHtml += `<span class="page-num" data-page="${i}">${i}</span>`;
      }
      paginationHtml += '<span class="next">Next</span>';
      paginationHtml += '</div>';
      $('.main-blog.category .blog-articles').append(paginationHtml);
    }
  
    function showPage(page) {
      currentPage = page;
      const start = (currentPage - 1) * articlesPerPage;
      const end = start + articlesPerPage;
  
      $articles.hide().slice(start, end).show();
  
      $('.pagination .page-num').removeClass('active').filter(`[data-page=${currentPage}]`).addClass('active');
      $('.pagination .prev').toggle(currentPage !== 1);
      $('.pagination .next').toggle(currentPage !== totalPages);
    }
  
    function attachEventHandlers() {
      $('.pagination .prev').click(function () {
        if (currentPage > 1) {
          showPage(currentPage - 1);
        }
      });
  
      $('.pagination .next').click(function () {
        if (currentPage < totalPages) {
          showPage(currentPage + 1);
        }
      });
  
      $('.pagination .page-num').click(function () {
        showPage($(this).data('page'));
      });
    }
  
    function initPagination() {
      generatePagination();
      attachEventHandlers();
      showPage(currentPage);
    }
    
    initPagination();
    if(width < 992){
      $('.blog-categories-mobile button.category-menu').click(function(){
        $(this).parent().siblings('.blog-categories').toggleClass('active');
      });
    }
  }
  
  let sizechartinterval;
  sizechartinterval = setInterval(() => {
    const sizechart = $('.product .product__info-wrapper .product__info-container div.shopify-app-block foxkit-sizechart-opener');
    if (sizechart.length) {
      $('.product .product__info-wrapper .product-form__input--pill.size > div.size_chart').append(sizechart);
      clearInterval(sizechartinterval);
    }
  }, 500);

  if($('body').data('templatename') == 'product'){
    let payjustnowinterval;
    payjustnowinterval = setInterval(() => {
      const $payjustnow = $('.product .product__info-wrapper product-info.product__info-container #pjn-product-container .pjn-text > p');
      if ($payjustnow.length) {
        var originalText = $payjustnow.html();
        $payjustnow.html('Or Checkout using <b>PayJustNow</b>' + originalText);
        clearInterval(payjustnowinterval);
      }
    }, 500);
    let payflexinterval;
    payflexinterval = setInterval(() => {
      const $payflex = $('.product .product__info-wrapper .product__info-container #partPayCalculatorWidget1 #partPayCalculatorWidgetText');
      if ($payflex.length) {
        var originalText = $payflex.find('.partPayCalculatorWidgetTextFromCopy').html();
          $payflex.find('.partPayCalculatorWidgetTextFromCopy').html(originalText + ' using <b>Playflex</b>');
        clearInterval(payflexinterval);
      }
    }, 500);
  }

  const duration = 2 * 60 * 1000;
  const intervalTime = 10 * 1000;
  
  function checkAndRemoveOverflow() {
      const body = document.querySelector('body');
      if (body.style.overflow === 'hidden') {
          body.style.overflow = '';
          // console.log('Removed overflow: hidden from body');
      }
  }
  const interval = setInterval(checkAndRemoveOverflow, intervalTime);
  setTimeout(() => {
      clearInterval(interval);
      // console.log('Interval cleared after 2 minutes');
  }, duration);


  const order = ["40MM","43MM","44MM","45MM","48MM","51MM","53MM","57MM","UK 2","UK 2.5","UK 3","UK 3.5","UK 4","UK 4.5","UK 5","UK 5.5","UK 6","UK 6.5","UK 7","UK 7.5","UK 8","UK 8.5","UK 9","UK 9.5","UK 10","UK 10.5","UK 11","UK 11.5","UK 12","UK 12.5","XXS","XS","S","S-M","S/M","M","L","L-XL","L/XL","XL","XXL","2XL","3XL","4XL","5XL","One Size","OSFA","OSFM","1","1.5","2","2.5","3","3.5","4","4.5","5","5.5","6","6.5","7","7.5","8","8.5","9","9.5","10","10.5","11","11.5","12","12.5","13","13.5","14","14.5","15","15.5","16","16.5","17","17.5","18","18.5","19","19.5","20","20.5","21","21.5","22","22.5","23","23.5","24","24.5","25","25.5","26","26.5","27","27.5","28","28.5","29","29.5","30","30.5","31","31.5","32","32.5","33","33.5","34","34.5","35","35.5","36","36.5","37","37.5","38","38.5","39","39.5","40","40.5","41","41.5","42","42.5","43","43.5","44","44.5","45","45.5","46","46.5","47","47.5","48","48.5","49","49.5","50","50.5","51","51.5","52","52.5","53","53.5","54","54.5","55","55.5","56","56.5","57","57.5","58","58.5","59","59.5","60","60.5","75","80","85","90","95","100","105","405","445"];
  
  // Get all the UL elements with the specific class
  const ulElements = document.querySelectorAll('.product-item .product-detail .product-options fieldset[name="size"] .custom-varient-box'); // Replace 'class-name' with the actual class name

  ulElements.forEach(ul => {
      // Get all LI elements inside the UL
      const liElements = Array.from(ul.querySelectorAll('.custom-varient-list'));

      // Sort LI elements based on the input value according to the desired order
      liElements.sort((a, b) => {
          const aValue = a.querySelector('input').value;
          const bValue = b.querySelector('input').value;
          return order.indexOf(aValue) - order.indexOf(bValue);
      });

      // Clear the UL
      ul.innerHTML = '';

      // Append the sorted LI elements back to the UL
      liElements.forEach(li => ul.appendChild(li));
  });
  const ulElements_1 = document.querySelectorAll('.product__info-wrapper .product__info-container variant-selects fieldset[name="size"] .custom-option-group:not(.owl-loaded)'); // Replace 'class-name' with the actual class name

  ulElements_1.forEach(ul => {
      // Get all LI elements inside the UL
      const liElements_1 = Array.from(ul.querySelectorAll('.custom-box-option'));

      // Sort LI elements based on the input value according to the desired order
      liElements_1.sort((a, b) => {
          const aValue = a.querySelector('input').value;
          const bValue = b.querySelector('input').value;
          return order.indexOf(aValue) - order.indexOf(bValue);
      });

      // Clear the UL
      ul.innerHTML = '';

      // Append the sorted LI elements back to the UL
      liElements_1.forEach(li => ul.appendChild(li));
  });
  function sizeoptionsorting() {
    let sortinginterval;
    sortinginterval = setInterval(() => {
    const ulElements1 = document.querySelectorAll('.card-wrapper .product-details .product-options select');
      ulElements1.forEach(ul => {
          // Get all LI elements inside the UL
          const liElements1 = Array.from(ul.querySelectorAll('option'));
    
          // Sort LI elements based on the input value according to the desired order
          liElements1.sort((a, b) => {
              const aValue = a.value;
              const bValue = b.value;
              return order.indexOf(aValue) - order.indexOf(bValue);
          });
    
          ul.innerHTML = '';
    
          liElements1.forEach(li => ul.appendChild(li));
        
          ul.classList.add('sorted');
      });
      const sizeoption = $('.card-wrapper .product-details .product-options select.sorted');
      // console.log('sizeoptions' + sizeoption.length)
      if (sizeoption.length) {
        clearInterval(sortinginterval);
      }
    }, 500);
  }

  sizeoptionsorting();
  $(document).on('change', '.facets-container facet-filters-form label, .facets-container facet-filters-form input',function(){
    setTimeout(function(){
      // console.log('sorting');
      sizeoptionsorting();
    }, 1500);
  });
  $(document).on('click', '.collection .facets-vertical .active-facets-vertical-filter facet-remove.active-facets__button-wrapper',function(){
    setTimeout(function(){
      // console.log('sorting removed');
      sizeoptionsorting();
    }, 1500);
  });


    // Function to sort and reorder child elements
    function sortElements(parent, orderArray, selector) {
        const elements = Array.from(parent.querySelectorAll(selector));
        elements.sort((a, b) => {
            const aValue = a.querySelector('input').value;
            const bValue = b.querySelector('input').value;
            return orderArray.indexOf(aValue) - orderArray.indexOf(bValue);
        });

        parent.innerHTML = '';
        elements.forEach(element => parent.appendChild(element));
    }

    // Sorting divs inside owl-stage
    const owlStage = document.querySelector('.product__info-wrapper .product__info-container variant-selects .product-form__input--pill.size .owl-stage');
    if (owlStage) {
        sortElements(owlStage, order, '.owl-item');
    }

  function popupchange(){
    if(window.innerWidth < 768){
      let foxkitpopupinterval;
      foxkitpopupinterval = setInterval(() => {
        var popup = $('.foxkit-modal__content .foxkit-popup__image img');
        if (popup.length) {
          popup.attr('src', 'https://cdn.shopify.com/s/files/1/0698/8175/7932/files/Popup_Customer_Notice_mobile.jpg?v=1720607439');
          clearInterval(foxkitpopupinterval);
        }
      }, 500);
    }
  }
  popupchange();
  $(window).resize(popupchange);

  if($('body').data('templatename') == 'product'){
    
    $('.product .product__info-wrapper variant-selects fieldset.product-form__input label').click(function() {
      setTimeout(function() {
        var selectvari = $(this).closest('variant-selects').siblings('.add-button-custom').find('input.product-variant-id').val();
        // console.log(selectvari);
        updateGemcodeDisplay(selectvari);      
      }.bind(this), 400);
    });
    function updateGemcodeDisplay(variantId) {
      var gemcode = '';
      for (var i = 0; i < gemcodeArray.length; i++) {
        if (gemcodeArray[i].id == variantId) {
          gemcode = gemcodeArray[i].gemcode;
          break;
        }
      }
      // console.log(gemcode);
      $('body.product[data-templatename=product] .product__info-wrapper product-info.product__info-container ul.pdp-prodcut-id.gencode span.h4 .gemcode').html(gemcode);
    }
  
    var selectvari = $('.product .product__info-wrapper .add-button-custom input.product-variant-id').val();
    updateGemcodeDisplay(selectvari);

    if($('body').data('product') == 'Zig Dynamica 5 - Test' || __productWizRioProduct.id == 8624505290988 || __productWizRioProduct.id == 8626596643052){
      $('.product .product__info-wrapper variant-selects fieldset.product-form__input[name="color"] label').click(function() {
        var images = $(this).data('images').split(', ');
    
        $('.product div#product_gallery_slider:not([style="display: none;"]) .rio-media-gallery .PwzrGrid-root .PwzrGrid-item img').each(function() {
          var imgSrc = $(this).attr('src');
          var imgSrcBase = imgSrc.replace(/^https?:\/\//, '').split('?')[0];
  
          var isMatch = images.some(function(image) {
            var imageBase = image.replace(/^https?:\/\//, '').split('?')[0];
            return imgSrcBase === imageBase;
          });
          
          if (isMatch) {
            $(this).closest('.PwzrGrid-item').show('slow');
          } else {
            $(this).closest('.PwzrGrid-item').hide('slow');
          }
        });
      });

      var selected_color_images = $('.product .product__info-wrapper variant-selects fieldset.product-form__input[name="color"] input[name="Color"]:checked + label').data('images').split(', ');
      $('.product div#product_gallery_slider:not([style="display: none;"]) .rio-media-gallery .PwzrGrid-root .PwzrGrid-item img').each(function() {
        var imgSrc = $(this).attr('src');
        var imgSrcBase = imgSrc.replace(/^https?:\/\//, '').split('?')[0];

        var isMatch = selected_color_images.some(function(image) {
          var imageBase = image.replace(/^https?:\/\//, '').split('?')[0];
          return imgSrcBase === imageBase;
        });
        
        if (isMatch) {
          $(this).closest('.PwzrGrid-item').show('slow');
        } else {
          $(this).closest('.PwzrGrid-item').hide('slow');
        }
      });
    }


    $('.custom-media-product-block .custom-media-varient-list .item input').each(function(){
      var fieldset = $(this).closest('fieldset');
      var variantsdata = JSON.parse($('variant-selects').find('[type="application/json"]').text());
      var option = $(this).val();
      
      // console.log("Selected option: ", selectoption);
      
      var options = variantsdata.filter(function(item) {
        return item.option2 == option && item.available == true;
      });
      
      // console.log("Filtered options: ", options);
      
      // console.log(options.length);
      if(options.length == 0){
        $(this).addClass('no_sizes');
      }
      if($(this).prop('checked') == true){
        var otherfieldset = fieldset.siblings('fieldset');
        otherfieldset.find('input').each(function(){
          var value = $(this).val();
          var match = options.some(function(option) {
            return option.option1 == value;
          });
  
          if (match) {
            $(this).removeClass('disabled');
          } else {
            $(this).addClass('disabled');
          }
        });
      }
    });
    
    $(document).on('click', '.custom-media-product-block .custom-media-varient-list .item label', function() {
      var fieldset = $(this).closest('fieldset');
      var variantsdata = JSON.parse($('variant-selects').find('[type="application/json"]').text());
      var selectoption = $(this).siblings('input').val();

      var options = variantsdata.filter(function(item) {
        return item.option2 == selectoption;
      });
  
      var otherfieldset = fieldset.siblings('fieldset');
      var firstMatchFound = false;
      var checkedMatchExists = false;

      otherfieldset.find('input:checked').each(function() {
          var value = $(this).val();
          var match = options.some(function(option) {
            return option.option1 == value && option.available == true;
          });
  
          if (match) {
            checkedMatchExists = true;
            return false;
          }
      });
      
      otherfieldset.find('input').each(function() {
        var value = $(this).val();
        var match = options.some(function(option) {
            return option.option1 == value && option.available == true;
        });

        if (match) {
          $(this).removeClass('disabled');
          if (!checkedMatchExists && !firstMatchFound) {
            $(this).prop('checked', true);
            firstMatchFound = true;
          }
        } else {
          $(this).addClass('disabled');
          if (!checkedMatchExists) {
            $(this).prop('checked', false);
          }
        }
      });
    });

    $('.product__info-wrapper product-info .swatch-input__label').each(function(){
      var variantsdata = JSON.parse($('variant-selects').find('[type="application/json"]').text());
      var label = $(this);
      var value = $(this).siblings('input').val();
      var fieldset = $(this).closest('fieldset');
      var options = variantsdata.filter(function(item) {
          return item.option2 == value;
      });
      var match = options.filter(function(option) {
        return option.compare_at_price != null;
      });
    
      if (options.length == match.length) {
         var saleBadge = $('<span class="sale_badge_color">sale</span>');
        label.find('.swatch').after(saleBadge);
      }
    });

    $('.product div#product_gallery_slider:not([style="display: none;"]) .rio-media-gallery .PwzrGrid-root .PwzrGrid-item img').each(function() {
      var imgSrc = $(this).attr('src');
      var imgSrcBase = imgSrc.split('?')[0];

      var isMatch = osimages.some(function(image) {
        var imageBase = image.split('?')[0];
        return imgSrcBase === imageBase;
      });
      
      if (isMatch) {
        $(this).closest('.PwzrGrid-item').show('slow');
      } else {
        $(this).closest('.PwzrGrid-item').hide('slow');
      }
    });
  }
});
